export default {
  list_professionals: "Lista de profissionais",
  register_professional: "Cadastrar profissional",
  update_professional: "Atualizar profissional",
  professional_data: "Dados do profissional",
  register_occupation_professional: "Cadastrar ocupação do profissional",
  update_occupation_professional: "Atualizar ocupação do profissional",
  remove_occupation_professional: "Remover ocupação do profissional",
  link_professionals_on_unity: "Vincular profissionais a unidade",
};
